import 'core-js/stable';
import 'regenerator-runtime/runtime';

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './fonts/fonts.css';
import { loadSurveyByLocation } from './surveyCollector/surveyLoading';
import { loadConfig } from './config';
import { goToFillInBlocked } from './uiState/states';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root was not found');
}

const root = createRoot(container);

loadConfig()
  .then((config) => {
    loadSurveyByLocation(config, location.href);
    root.render(<App />);
  })
  .catch((error) => {
    console.error(error);

    goToFillInBlocked('Unexpected error');
    root.render(<App />);
  });

/**
 * reší scrolling na aktivní prvek na android zařízeních při zobrazení klávesnice
 * https://gitlab.commity.cz/skoda/xperience/issues/234
 */
if (/Android/.test(navigator.userAgent)) {
  window.addEventListener('resize', function () {
    if (
      document.activeElement &&
      (document.activeElement.tagName === 'INPUT' ||
        document.activeElement.tagName === 'TEXTAREA')
    ) {
      window.setTimeout(function () {
        if (!document.activeElement) {
          return;
        }

        const textInputElementRoot =
          (document.activeElement.closest &&
            document.activeElement.closest('[data-textInput-scroll-point]')) ||
          document.activeElement;

        textInputElementRoot.scrollIntoView();
      }, 10);
    }
  });
}
